// extracted by mini-css-extract-plugin
module.exports = {"cell":"VirtualTableRowCell-cell-JYEEO TableRowCell-cell-2fbg4"};